import { render, staticRenderFns } from "./ChannelCurvesChartMulti.vue?vue&type=template&id=42f2c66d&"
import script from "./ChannelCurvesChartMulti.vue?vue&type=script&lang=js&"
export * from "./ChannelCurvesChartMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports